<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <h3>Case study van Noorderbreedte</h3>
        <h1>
          Hoe de behandelaars van Noorderbreedte Revalidatie gezamenlijk
          wekelijks 60 uur met Roosterplatform besparen
        </h1>
        <p>
          Wekelijks besparen de fysiotherapeuten en andere behandelaars van
          Noorderbreedte Revalidatie in Leeuwarden 60 uur aan plantijd met
          Roosterplatform. Deze vrijgekomen tijd besteden ze nu aan betere zorg
          voor mensen die na een ziekenhuisopname bij Noorderbreedte verder
          herstellen van bijvoorbeeld een beroerte of een gebroken heup. Of aan
          dagbehandeling voor mensen met de ziekte van Parkinson die zo lang
          mogelijk thuis willen blijven wonen.
        </p>
        <img
          src="../assets/img/clients/hero-noorderbreedte.png"
          alt="Roosterplatform webinar"
        >
        <div>
          <small
            class="opacity"
          >Plaatje afkomstig van de website van Noorderbreedte</small>
        </div>
      </div>
    </div>

    <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>Uitdaging</span>
          <h3>Steeds meer en betere zorg met steeds minder personeel</h3>
        </div>
        <p>
          Bij Noorderbreedte voelen ze dagelijks dat de vraag naar zorg stijgt
          en het tekort aan personeel groeit. Op dit moment zijn er volgens het
          ministerie van VWS tachtigduizend zorgmedewerkers te weinig. "Door de
          grote zorgvraag en het personeelstekort is het ontzettend belangrijk
          om onze behandelaars zo efficiënt mogelijk in te zetten," stelt Irene
          de Boer, Proces & Relatiebeheerder bij Noorderbreedte, waar zij zich
          onder meer richt op capaciteits- en programmamanagement.
        </p>
        <p>
          Bij Noorderbreedte voelen ze dagelijks dat de vraag naar zorg stijgt
          en het tekort aan personeel groeit. Op dit moment zijn er volgens het
          ministerie van VWS tachtigduizend zorgmedewerkers te weinig. "Door de
          grote zorgvraag en het personeelstekort is het ontzettend belangrijk
          om onze behandelaars zo efficiënt mogelijk in te zetten," stelt Irene
          de Boer, Proces & Relatiebeheerder bij Noorderbreedte, waar zij zich
          onder meer richt op capaciteits- en programmamanagement. helpen.
          Daarvoor is het belangrijk dat behandelaars inzicht hebben in welke
          behandelingen het beste werken. "Verder vragen
          ziektekostenverzekeraars gegevens van ons waarmee ze de juiste
          behandelingen kunnen aanbieden. Bijvoorbeeld wat het beste
          behandelschema is voor iemand die van een hersenbloeding herstelt. En
          om dat inzicht en die gegevens te leveren hadden wij de hulp van
          Roosterplatform nodig."
        </p>
        <div class="section-title">
          <span>Gevolgen</span>
          <h3>Veel tijd kwijt aan planning en verspillen van behandelingen</h3>
        </div>
        <p>
          Want de behandelaars van Noorderbreedte planden hun afspraken zelf.
          Irene: "En dat was dan inclusief afzeggingen verwerken en afspraken
          verplaatsen. En aan die administratie waren ze veel tijd kwijt die ze
          veel beter en liever aan herstelzorg besteden."
        </p>
        <p>
          Daar kwam bij dat behandelaars geregeld te veel behandelingen gaven
          door te weinig inzicht in voorgeschreven en toegestane behandelingen.
          Dit kostte onnodig geld en gaf problemen met ziektekostenverzekeraars
          over vergoedingen. "Wij waren dus dringend op zoek naar een goede
          oplossing en zo kwamen wij bij Roosterplatform uit."
        </p>
        <div class="section-title">
          <span>Oplossing</span>
          <h3>
            Roosterplatform plant automatisch en geeft compleet behandelinzicht
          </h3>
        </div>
        <p>
          Noorderbreedte plant nu volledig geautomatiseerd met Roosterplatform.
          Eenmalig geeft men bijvoorbeeld de minimale rusttijd tussen
          behandelingen in en Roosterplatform doet de rest. Daardoor hoeven de
          behandelaars geen tijd meer aan plannen te besteden. En hebben ze via
          Roosterplatform ook compleet inzicht in:
        </p>
        <ul>
          <li>Hoeveel uur per cliënt ingezet is.</li>
          <li>Wat het aantal voorgeschreven uren voor een behandeling is.</li>
          <li>Welke capaciteit nog beschikbaar is.</li>
        </ul>
        <p>
          "Ook vanuit management hadden wij een programma nodig om inzicht te
          krijgen en dat vervolgens te kunnen toetsen, en met Roosterplatform
          hebben we dat nu." Hierdoor stemt Noorderbreedte de zorgvraag en de
          beschikbare capaciteit optimaal af. Cliënten krijgen zo de beste
          behandeling en behandelaars werken zo efficiënt mogelijk.
        </p>
        <div class="section-title">
          <span>Resultaat</span>
          <h3>
            Nu meer tijd voor betere zorg en mogelijkheden voor vernieuwen
          </h3>
        </div>
        <p>
          "Door Roosterplatform besparen onze behandelaars 60 uur oftewel 1,5
          FTE per week," rekent Irene voor. Deze vrijgekomen tijd besteden de
          behandelaars nu direct aan betere herstelzorg zoals ze het liefst
          doen. En verder werken ze ook prettiger doordat ze meteen kunnen zien
          of een behandeling in de planning past.
        </p>
        <p>
          Daarnaast behaalt Norschoten de volgende voordelen met
          Roosterplatform:
        </p>
        <p>
          Na de behaalde besparing en optimalisatie vernieuwt Noorderbreedte ook
          dankzij Roosterplatform. Zo bieden de behandelaars nu
          groepsbehandelingen aan. Lotgenoten delen daarin hun ervaringen en
          steunen elkaar. Vroeger was dit te ingewikkeld om te plannen, maar nu
          plant Roosterplatform een complete groepsbehandeling in een paar
          minuten en helpt een behandelaar meerdere cliënten tegelijk weer
          zelfstandig op de been.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Noorderbreedte",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Noorderbreedte",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
img {
  border-radius: $border-radius;
}

p + .section-title {
  margin-top: 50px;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
